'use client';

import React from 'react';
import ContactContent from './ContactContent';

/**
 * Contact Page Component
 * 
 * This component renders the complete contact page using the original design
 * while following proper component organization principles.
 */
export default function ContactPage() {
  return <ContactContent />;
}
